import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { signupUser } from './authSlice';
import './Signup.scss';  // Assurez-vous que le chemin est correct
import './auth.scss';

function Signup() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    rePassword: ''
  });

  const { isLoading, isError, isSuccess, message } = useSelector(state => state.auth);
  const dispatch = useDispatch();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(signupUser(formData));
  };

  return (
    <div>
      <form onSubmit={handleSubmit} className="signup-form">
        <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} placeholder="Name" />
        <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} placeholder="Surname" />
        <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Mail" />
        <input type="password" name="password" value={formData.password} onChange={handleChange} placeholder="Password" />
        <input type="password" name="rePassword" value={formData.rePassword} onChange={handleChange} placeholder="Repeat Password" />
        <button type="submit" disabled={isLoading}>{isLoading ? 'Loading...' : 'Sign Up'}</button>
      </form>
      {isError && <div className="alert error">{message}</div>}
      {isSuccess && <div className="alert success">Signup Successful!</div>}
    </div>
  );
}

export default Signup;
